package com.devi3east.bashbuddy.cart.results

import com.devi3east.bashbuddy.exceptions.InventoryErrorResponse
import com.devi3east.bashbuddy.purchase.responses.PurchaseInitResponse

sealed class CheckoutResult {
    data class Success(val response: PurchaseInitResponse) : CheckoutResult()
    data class InventoryError(val error: InventoryErrorResponse) : CheckoutResult()
    data class Failure(val exception: Throwable) : CheckoutResult()
    data object Cancelled : CheckoutResult()
}